import { finish, error } from '../../../modules/competitions/actions/query';
import api from '../../../api';

export function request(dispatch, action) {
    console.trace('Reducer request competitions');
    // TODO: Remove comment after refactor all components with the reducer
    // api.get('/competitions', action.query, { cache: true }).then(
    //     (competitions) => dispatch(finish(action.id, competitions)),
    //     ({ errors }) => dispatch(error(action.id, errors))
    // );

    let query = undefined;
    if (action.query) {
        query = {
            sport: action.query?.sport,
            name: action.query?.name,
            ngram: action.query?.['name.ngram'],
            perPage: action.query?.perPage
        };
    }

    $appState.sdkStaff.getCompetitions({
        requestBody: query
    })
        .then(competitions => dispatch(finish(action.id, competitions)))
        .catch(errors => dispatch(error(action.id, errors)));

}
